import { writable } from "svelte/store";
import { service } from "./services";
import type {  ApiResultOfListOfCampaignsDTO, CampaignsDTO } from "./walletapi";

export const Promotionalcredits = writable<CampaignsDTO[]>([]);

export async function RefreshCampaigns() {
    try {
        let response: ApiResultOfListOfCampaignsDTO = await service.walletapi.campaignsList({
            Token: sessionStorage.token,
        });

        if (response.Success && response.Data) {
            // Crear una nueva lista para forzar la reactividad
            Promotionalcredits.set([...response.Data]);
        }
    } catch (error) {
        // Error handling without console.log
    }
}

export function CampaignsChanged(promotionalcredit: CampaignsDTO) {
    Promotionalcredits.update(list => {
        let transactionIndex = list.findIndex(t => t.Id == promotionalcredit.Id);
        if (transactionIndex == -1) {
            // Si la transacción no está en la lista, la agregamos al inicio
            return [promotionalcredit, ...list];
        }
        
        // console.log('Actualizando transacción:', {
        //     id: promotionalcredit.Id,
        //     oldType: list[transactionIndex].Type,
        //     newType: promotionalcredit.Type,
        //     oldAmount: list[transactionIndex].promotionalcredit?.InCents,
        //     newAmount: promotionalcredit.CashableAmount?.InCents,
        //     oldBalance: list[transactionIndex].promotionalcredit?.InCents,
        //     newBalance: promotionalcredit.CashableBalance?.InCents
        // });

        // Crear una nueva lista con la transacción actualizada
        const newList = [...list];
        newList[transactionIndex] = promotionalcredit;
        return newList;
    });
}

export function CampaignsAdded(promotionalcredit: CampaignsDTO) {

    Promotionalcredits.update(list => {
        const newList = [promotionalcredit, ...list];
        while (newList.length > 100) {
            newList.pop();
        }
        return newList;
    });
}
